import ScrollCarousel from "@/components/Carousel/scroll-carousel";
import Image from "@/components/Image/image";
import SbEditable from "storyblok-react";
import styles from "./testimonial-cards.module.scss";
import type { TestimonialCardsStoryblok } from "./types";

interface Props {
  blok: TestimonialCardsStoryblok;
}

const TestimonialCards = ({ blok }: Props) => {
  const items = Array.isArray(blok.testimonials) ? blok.testimonials : [];

  return (
    // @ts-expect-error
    <SbEditable content={blok}>
      <div className={styles.testimonials}>
        <div className={styles.testimonialsSurface}>
          <ScrollCarousel
            variant="testimonial"
            className={styles.testimonialsCarousel}
          >
            {items.length
              ? items.map((item) => (
                  <div key={item._uid} className={styles.testimonialCard}>
                    <div className={styles.testimonialCardBody}>
                      {item.author_image?.filename ? (
                        <div className={styles.testimonialAvatar}>
                          <Image
                            filename={item.author_image.filename}
                            alt={item.author_name || ""}
                            aspectMobile="1/1"
                            aspectDesktop="1/1"
                            sizes="48px"
                            className={styles.imageFillParent}
                          />
                        </div>
                      ) : null}
                      {item.quote ? (
                        <blockquote className={styles.testimonialQuote}>
                          &ldquo;{item.quote}&rdquo;
                        </blockquote>
                      ) : null}
                    </div>
                    {item.author_name || item.author_role ? (
                      <div className={styles.testimonialMeta}>
                        {item.author_name ? (
                          <span className={styles.testimonialName}>
                            {item.author_name}
                          </span>
                        ) : null}
                        {item.author_role ? (
                          <span className={styles.testimonialRole}>
                            {item.author_role}
                          </span>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                ))
              : null}
          </ScrollCarousel>
        </div>
      </div>
    </SbEditable>
  );
};

export default TestimonialCards;
